import { render, staticRenderFns } from "./PortfolioView.vue?vue&type=template&id=243e4f8c&"
import script from "./PortfolioView.vue?vue&type=script&lang=js&"
export * from "./PortfolioView.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioView.vue?vue&type=style&index=0&id=243e4f8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports